import {
	BaseQueryFn,
	FetchArgs,
	fetchBaseQuery,
	FetchBaseQueryError,
	FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react';

import { notification } from 'antd';

import { EErrorCodes } from 'shared/typings';
import { getAuthToken, logoutKeycloak } from 'shared/utils';

export const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta> = async (
	args,
	api,
	extraOptions,
) => {
	const authToken = await getAuthToken();
	const result = await fetchBaseQuery({
		baseUrl: import.meta.env.VITE_API_BASE_URL || '/',
		prepareHeaders: (headers) => {
			headers.set('Accept', 'application/json');
			headers.set('X-Referer', document.location.href);
			authToken && headers.append('Authorization', `Bearer ${authToken}`);
			return headers;
		},
		paramsSerializer: (params) => {
			const searchParams = new URLSearchParams();

			Object.entries(params).forEach(([key, value]) => {
				if (Array.isArray(value)) {
					value.forEach((v) => searchParams.append(key, v));
				} else if (value !== null && value !== undefined) {
					searchParams.append(key, value.toString());
				}
			});

			return searchParams.toString();
		},
	})(args, api, extraOptions);

	const statusCode = result.meta?.response?.status;

	if (statusCode === EErrorCodes.UNAUTHORIZED || statusCode === EErrorCodes.FORBIDDEN) {
		logoutKeycloak();
	}

	if (
		statusCode === EErrorCodes.BAD_REQUEST ||
		statusCode === EErrorCodes.BAD_GATEWAY ||
		statusCode === EErrorCodes.INTERNAL_SERVER_ERRROR ||
		statusCode === EErrorCodes.TOO_MANY_REQUESTS ||
		statusCode === EErrorCodes.PAGE_NOT_FOUND
	) {
		const text = result.meta?.response?.statusText;

		notification.error({
			title: `${statusCode} - ${text}`,
			placement: 'topRight',
			showProgress: true,
			pauseOnHover: true,
		});
	}

	return result;
};
